export default "__VITE_ASSET__BSIqb_7i__"